(function () {
  // "Pack Size" and "Subscription Savings" are line-item properties set once
  // at add-to-cart time (static Shopify metadata) — neither updates on its own
  // when the customer later changes quantity with the cart's native +/-
  // stepper. Recompute and repaint both here so they always reflect the
  // current quantity/price for that line.
  const CUPS_PER_QUANTITY_UNIT = 6;
  // The 6-pack (quantity 1) never had a Subscribe & Save option on the
  // product page — only 12/18/24-pack (quantity 2/3/4) do. If the customer
  // uses the cart's generic +/- stepper to shrink a subscribed line down to
  // quantity 1, hide the savings line rather than show savings for a tier
  // that was never actually offered as subscribable.
  const MIN_SUBSCRIBABLE_QUANTITY = 2;

  function findPropertyValueEl(row, label) {
    const dt = Array.from(row.querySelectorAll('.product-option dt')).find(
      (el) => el.textContent.trim() === label
    );
    return dt ? dt.nextElementSibling : null;
  }

  function recomputePackSize(row) {
    const quantityInput = row.querySelector('.quantity__input');
    const dd = findPropertyValueEl(row, 'Pack Size:');
    if (!quantityInput || !dd) return;

    const quantity = parseInt(quantityInput.value, 10);
    if (!quantity) return;

    const newText = `${quantity * CUPS_PER_QUANTITY_UNIT} Pack`;
    if (dd.textContent.trim() !== newText) dd.textContent = newText;
  }

  function recomputeSavings(row) {
    const dd = findPropertyValueEl(row, 'Subscription Savings:');
    if (!dd) return;
    const propertyRow = dd.closest('.product-option');

    const quantityInput = row.querySelector('.quantity__input');
    const quantity = parseInt(quantityInput?.value, 10);

    if (!quantity || quantity < MIN_SUBSCRIBABLE_QUANTITY) {
      if (propertyRow) propertyRow.style.display = 'none';
      return;
    }
    if (propertyRow) propertyRow.style.display = '';

    // Cart-level compare-at/final line prices don't reliably differ for
    // selling-plan items (the discount is baked into the line price itself,
    // not treated as a line-level discount) — Shopify still renders the real
    // per-unit before/after selling-plan prices via item.selling_plan_allocation,
    // which the row carries as data attributes so this can scale with the
    // live quantity instead of drifting from what's actually charged.
    const compareAtRaw = row.dataset.sellingPlanUnitCompareAtPrice;
    const priceRaw = row.dataset.sellingPlanUnitPrice;
    if (!compareAtRaw || !priceRaw) return;

    const compareAtMatch = compareAtRaw.match(/[\d.,]+/);
    const priceMatch = priceRaw.match(/[\d.,]+/);
    if (!compareAtMatch || !priceMatch) return;

    const compareAtNumeric = parseFloat(compareAtMatch[0].replace(/,/g, ''));
    const priceNumeric = parseFloat(priceMatch[0].replace(/,/g, ''));
    const unitSavings = compareAtNumeric - priceNumeric;
    if (!(unitSavings > 0)) return;

    const savings = unitSavings * quantity;
    const decimals = compareAtMatch[0].includes('.') ? 2 : 0;
    const newText = `Save ${compareAtRaw.replace(compareAtMatch[0], savings.toFixed(decimals))}`;
    if (dd.textContent.trim() !== newText) dd.textContent = newText;
  }

  function recomputeRow(row) {
    if (!row) return;
    recomputePackSize(row);
    recomputeSavings(row);
  }

  function recomputeAll() {
    document.querySelectorAll('.cart-item').forEach(recomputeRow);
  }

  document.addEventListener('change', (event) => {
    if (event.target.classList && event.target.classList.contains('quantity__input')) {
      recomputeRow(event.target.closest('.cart-item'));
    }
  });

  // The theme republishes this event (assets/cart.js) after it replaces the
  // cart row markup with a fresh server render, which would otherwise
  // re-introduce the stale value baked into the line-item property.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, recomputeAll);
  }

  recomputeAll();
})();
